/**
 * Created by claudenbach on 1/30/2017.
 */

import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmButtonFormatter = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  const displayValue = columnDef.displayField.title ? lmFormatUtilService.formatMessageRule(columnDef.displayField.title, dataView) : '';
  return lmFormatterService.formatButtonText(row, cell, displayValue, columnDef, dataView, dataGrid);
};
